module.exports = __webpack_public_path__ + "img/gift7.3d3b0015.png";